import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { FilterOpts } from "@saleor/types";
import { createBooleanField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum SoldoutCustomPageFilterKeys {
  isPublished = "isPublished",
  trackInventory = "trackInventory"
}

export interface SoldoutCustomPageListFilterOpts {
  isPublished: FilterOpts<boolean>;
  trackInventory: FilterOpts<boolean>;
}

const messages = defineMessages({
  isPublished: {
    defaultMessage: "isPublished",
    description: "isPublished"
  },
  trackInventory: {
    defaultMessage: "trackInventory",
    description: "trackInventory"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: SoldoutCustomPageListFilterOpts
): IFilter<SoldoutCustomPageFilterKeys> {
  return [
    {
      ...createBooleanField(
        SoldoutCustomPageFilterKeys.isPublished,
        intl.formatMessage(messages.isPublished),
        opts.isPublished.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.isPublished.active
    },
    {
      ...createBooleanField(
        SoldoutCustomPageFilterKeys.trackInventory,
        intl.formatMessage(messages.trackInventory),
        opts.trackInventory.value,
        {
          negative: intl.formatMessage(commonMessages.no),
          positive: intl.formatMessage(commonMessages.yes)
        }
      ),
      active: opts.trackInventory.active
    }
  ];
}
